module.exports = __webpack_public_path__ + "img/stage-4-motion.b84f5ca4.png";